<template>
  <OrganizationContext>
    <DomainVerificationTabs>
      <RouterView />
    </DomainVerificationTabs>
  </OrganizationContext>
</template>

<script lang="ts" setup>
import { RouteName } from '@/types/router'
import { useDomainVerificationsContext } from '@/composables/deepadmin/use-domain-verifications-context.ts'
import { useBreadcrumbRegistry } from '@/composables/use-breadcrumb-registry.ts'
import DomainVerificationTabs from '@/components/deepadmin/domain-verifications/DomainVerificationTabs.vue'
import OrganizationContext from '@/components/deepadmin/organization/OrganizationContext.vue'

const { overrideBreadcrumb } = useBreadcrumbRegistry()
const { selectedDomain } = useDomainVerificationsContext()

definePage({
  meta: {
    breadcrumbLabelKey: '',
  },
})

watch(
  selectedDomain,
  (newValue) => {
    if (!newValue) return

    overrideBreadcrumb(
      '/organizations/[organizationId]/organization/settings/security/domain-verifications/[domainVerificationId]' as RouteName,
      newValue.domainName || '',
    )
  },
  { immediate: true },
)
</script>
